import styled from "styled-components";

export const FormContainer = styled.div`
    margin-top: 20px;
    padding: 20px !important;
    background-color: ${props => props.theme.cores.fundo.container.secundario};
    border-radius: 4px;
    border: 1px solid ${props => props.theme.cores.fundo.container.secundario};
    box-shadow: ${props=>props.theme.sombras.padrao}
`;